export class AndroidStrategy {
  onSuccess(boxNumber, citiboxId, deliveryId) {
    window.CitiboxCourierSDK.onSuccess(boxNumber, citiboxId || '', deliveryId);
  }

  onError(errorCode) {
    window.CitiboxCourierSDK.onError(errorCode);
  }

  onFail(failureCode) {
    window.CitiboxCourierSDK.onFail(failureCode);
  }

  onCancel(cancelCode) {
    window.CitiboxCourierSDK.onCancel(cancelCode);
  }

  openBLE(url, mac, ssid, serviceUUID, scommandUUID, sreplyUUID, openToken, otaServiceUUID, otaControlUUID, otaDataUUID) {
    window.CitiboxCourierSDK.openBLE(url, mac, serviceUUID, scommandUUID, sreplyUUID, openToken, otaServiceUUID, otaControlUUID, otaDataUUID);
  }

  cancelOpenBLE() {
    window.CitiboxCourierSDK.cancelOpenBLE();
  }

  blePermissionsStatus() {
    window.CitiboxCourierSDK.blePermissionsStatus();
  }

  characteristicsSDK() {
    if (window.CitiboxCourierSDK?.characteristicsSDK) {
      window.CitiboxCourierSDK.characteristicsSDK();
    }
  }

  sdkInfo() {
    if (window.CitiboxCourierSDK?.sdkInfo) {
      window.CitiboxCourierSDK.sdkInfo();
    }
  }

  onSessionToken(sessionToken) {
    if (window.CitiboxCourierSDK?.onSessionToken) {
      window.CitiboxCourierSDK.onSessionToken(sessionToken);
    }
  }
}
